import axios from "axios";
import { API_PATHS } from "../../paths";
import UpcomingEventItem from "../../Model/UpcommingEventsModel";
import { flashMessage } from "../../../utils/flashMessageService";

/**
 * GET /api/upcomingevents
 */
export async function fetchUpcomingEvents(payload = {}) {
  try {
    const res = await axios.get(API_PATHS.upcomingEvents, {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      params: payload,
    });
    const items = res.data || [];
    return items.map((i) => UpcomingEventItem.fromJSON(i));
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error("fetchUpcomingEvents failed with status 400:", error.response.data);
      flashMessage(`fetchUpcomingEvents failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error("Error fetching upcoming events:", error);
      flashMessage("fetchUpcomingEvents failed. Please try again.", { type: "error" });
    }
    console.error("fetchUpcomingEvents error:", error);
    throw error;
  }
}

/**
 * POST /api/upcomingevents
 */
export async function createUpcomingEvent(payload = {}) {
  try {
    const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
    const body = isFormData ? payload : (() => {
      const fd = new FormData();
      Object.entries(payload).forEach(([k, v]) => { if (v !== undefined && v !== null) fd.append(k, v); });
      return fd;
    })();

    const res = await axios.post(API_PATHS.upcomingEvents, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        "Content-Type": "multipart/form-data",
      },
    });
    flashMessage("Upcoming event created successfully.", { type: "success" });
    return UpcomingEventItem.fromJSON(res.data);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error("createUpcomingEvent failed with status 400:", error.response.data);
      flashMessage(`createUpcomingEvent failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error("Error creating upcoming event:", error);
      flashMessage("createUpcomingEvent failed. Please try again.", { type: "error" });
    }
    console.error("createUpcomingEvent error:", error);
    throw error;
  }
}

/**
 * GET /api/upcomingevents/:id
 */
export async function fetchUpcomingEventById(id) {
  try {
    const res = await axios.get(API_PATHS.upcomingEventsById(id), {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    return UpcomingEventItem.fromJSON(res.data);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error(`fetchUpcomingEventById(${id}) failed with status 400:`, error.response.data);
      flashMessage(`fetchUpcomingEventById failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error(`Error fetching upcoming event by ID (${id}):`, error);
      flashMessage("fetchUpcomingEventById failed. Please try again.", { type: "error" });
    }
    console.error(`fetchUpcomingEventById(${id}) error:`, error);
    throw error;
  }
}

/**
 * PUT /api/upcomingevents/:id
 */
export async function updateUpcomingEvent(id, payload = {}) {
  try {
    const isFormData = typeof FormData !== 'undefined' && payload instanceof FormData;
    const body = isFormData ? payload : (() => {
      const fd = new FormData();
      Object.entries(payload).forEach(([k, v]) => { if (v !== undefined && v !== null) fd.append(k, v); });
      return fd;
    })();

    const res = await axios.put(API_PATHS.upcomingEventsById(id), body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        "Content-Type": "multipart/form-data",
      },
    });
    flashMessage("Upcoming event updated successfully.", { type: "success" });
    return UpcomingEventItem.fromJSON(res.data);
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error("updateUpcomingEvent failed with status 400:", error.response.data);
      flashMessage(`updateUpcomingEvent failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error("Error updating upcoming event:", error);
      flashMessage("updateUpcomingEvent failed. Please try again.", { type: "error" });
    }
    console.error(`updateUpcomingEvent(${id}) error:`, error);
    throw error;
  }
}

/**
 * DELETE /api/upcomingevents/:id
 */
export async function deleteUpcomingEvent(id) {
  try {
    const res = await axios.delete(API_PATHS.upcomingEventsById(id), {
      headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
    });
    flashMessage("Upcoming event deleted successfully.", { type: "success" });
    return res.data;
  } catch (error) {
    if (axios.isAxiosError(error) && error.response && error.response.status === 400) {
      console.error(`deleteUpcomingEvent(${id}) failed with status 400:`, error.response.data);
      flashMessage(`deleteUpcomingEvent failed: ${error.response.data.error}`, { type: "error" });
    } else {
      console.error(`Error deleting upcoming event (${id}):`, error);
      flashMessage("deleteUpcomingEvent failed. Please try again.", { type: "error" });
    }
    console.error(`deleteUpcomingEvent(${id}) error:`, error);
    throw error;
  }
}
